import React from 'react';
import Footer from '../components/Footer';
import Pyramid from '../components/pyramid/Pyramid';

function LearnNumbers() {
	return (
		<div>
			<Pyramid />
			<Footer />
		</div>
	);
}

export default LearnNumbers;
